module.exports = __webpack_public_path__ + "img/graph_1.eb88ac7c.png";